// import external dependencies
import 'jquery';
import { fez } from '@trepanation-pray/fez';

const menuItem = $('.o-primary-navigation__list li');

function toggleMenuItemState(element, active) {
  element.toggleClass('active', active);
}

// Mouse event handlers
menuItem.on('mouseenter', function () {
  toggleMenuItemState($(this), true);
});

menuItem.on('mouseleave', function () {
  toggleMenuItemState($(this), false);
});

// Set initial state on page load
menuItem.each(function () {
  const $this = $(this);
  if ($this.is(':hover')) {
    toggleMenuItemState($this, true);
  }
});



// Import everything from autoload
import './autoload/_bootstrap.js'

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';

// import icons
import { faYoutube, faFacebook, faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons';

import { faSearch, faGlobeEurope, faEnvelope, faCog } from '@fortawesome/pro-solid-svg-icons';

import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

// add the imported icons to the library
library.add(faYoutube, faFacebook, faTwitter, faLinkedin, faSearch, faChevronRight, faGlobeEurope, faEnvelope, faCog);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});
fez({ offset: 50 });
// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js